export default {
  computed: {
    computedClass () {
      return { 'is-invalid': this.showInvalid, 'is-valid': this.showValid, 'is-disabled': this.disabled }
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/computedClass.js